<button style="height: 30px;" mat-flat-button color="primary" [matMenuTriggerFor]="menu">
  Action <mat-icon>move_down</mat-icon>
</button>


<mat-menu #menu="matMenu">
  <button class="custom-menu-item" mat-menu-item (click)="openOwnerModal('user')">Change owner <mat-icon>person</mat-icon></button>
  <button class="custom-menu-item" mat-menu-item (click)="openOwnerModal('secondaryUser')">Change secondary owner <mat-icon>person</mat-icon></button>
  <!-- <button class="custom-menu-item" mat-menu-item>Remove <mat-icon>person_remove</mat-icon></button> -->
  <button class="custom-menu-item" mat-menu-item (click)="stopMessages()">{{isStopMessage? 'Allow messages':'Stop messages'}}<mat-icon>{{isStopMessage? 'add_comment':'speaker_notes_off'}}</mat-icon></button>
</mat-menu>